export default "__VITE_ASSET__bae0e42f__"